import request from './request2'


/**
 * 获取设备唤醒
 */
export function getAwakeDeviceApi(license) {
    return request({
        url: `api/front/monitor/quipment/wakeUpEquipment/${license}`,
        method: 'get'
    })
}

/**
 * 获取设备状态
 */

export function getDeviceStatusApi(license) {
    return request({
        url: `api/front/monitor/quipment/getEquipmentStatus/${license}`,
        method: 'get'
    })
}

/**
 * 移动设备
 */
export function moveDeviceApi(data) {
    return request({
        url: `api/front/monitor/quipment/ctrlPTZ`,
        method: 'post',
        data: {
            step: 20,
            ptzType: 0,
            ...data
        },
    })
}

/**
 * 通知设备进行物理理变焦
 */
export function setAdjustFocalLengthApi(data) {
    return request({
        url: `api/front/monitor/quipment/setAdjustFocalLength`,
        method: 'post',
        data,
    })
}

/**
 * 查询设备云端录像⽇日历
 */
export function getVideoQueryCalendar(data) {
    return request({
        url: `api/front/monitor/quipment/getVideoQueryCalendar`,
        method: 'post',
        data,
    })
}

/**
 * 查询设备云端录像列列表
 */
export function getVideoQueryListApi(data) {
    return request({
        url: `api/front/monitor/quipment/getVideoQueryList`,
        method: 'post',
        data,
    })
}


/**
 * 查询设备云端图⽚片列列表
 */
export function getPictureQueryListApi(data) {
    return request({
        url: `api/front/monitor/quipment/GetLocalFileList`,
        method: 'post',
        data,
    })
}

/**
 * 查询设备本地录像日历
 */
export function GetLocalFileCalendar(data) {
    return request({
        url: `api/front/monitor/quipment/GetLocalEventCalendar`,
        method: 'post',
        data,
    })
}

/**
 * 查询设备本地录像列列表
 */
export function getLocalFileList(data) {
    return request({
        url: `api/front/monitor/quipment/getLocalFileList`,
        method: 'post',
        data,
    })
}

/**
 * 查询设备本地录像列列表
 *
 */
export function getMultiMediaRecordAddr(data) {
    return request({
        url: `api/front/monitor/quipment/GetMultiMediaAddr`,
        method: 'post',
        data,
    })
}

/**
 * 查询设备本地图⽚片列列表(须设备在线才可查询)
 */
export function getGetLocalImgListApi(data) {
    return request({
        url: `api/front/monitor/quipment/getGetLocalPicList`,
        method: 'post',
        data,
    })
}

/**
 * 通知设备立即进行抓图操作
 */
export function noticeDeviceUploadPicRequestApi(data) {
    return request({
        url: `api/front/monitor/quipment/noticeDeviceUploadPicRequest`,
        method: 'post',
        data,
    })
}

/**
 * 根据摄像头获取关联的标签信息（用在普通用户绑定的监控）
 */
export function getUserMacsEquipmentsApi(data) {
    return request({
        url: `api/front/monitor/quipment/getUserMacsEquipments`,
        method: 'post',
        data,
    })
}

/**
 * 亮灯
 */
export function controlLightApi2(data,token) {
    return request({
        url: `api/front/order/control/light2`,
        method: 'post',
        data,
        headers: {
            'authori-zation': token
        }
    })
}

/**
 * 获取当前亮灯用户
 */
export function getOpenLightUserinfoApi2(data,token) {
    console.log(data)
    console.log(token)
    return request({
        url: `api/front/order/light/userinfo2`,
        method: 'post',
        data,
        headers: {
            'authori-zation':token
        }
    })
}
export function getListByBatchesIdsApi(data, token) {
    return request({
        url: `api/front/monitor/quipment/getListByBatchesId`,
        method: 'get',
        params: data, // GET请求通过params传递参数（对应后端@GetMapping接收）
        headers: {
            'authorization': token // 修正拼写错误：authori-zation → authorization
        }
    })
}
export function openDeviceApi(data, token) {
    return request({
        url: `api/front/merchant/autofeeding-device/timer/openDevice`,
        method: 'post',
        data,
        headers: {
            'authori-zation':token
        }
    })
}

/**
 * 亮灯结果
 */
export function getOpenLightResultApi2(data,token) {
    return request({
        url: `api/front/order/light/result2`,
        method: 'post',
        data,
        headers: {
            'authori-zation': token
        }
    })
}